import _ from 'lodash';

import { ReportItemNestedDataGroup, ReportItemNestedDataRow } from '../report.types';

const mergeReportNestedItemRows = (
  data: ReportItemNestedDataRow[],
  keyMap: { [key: string]: boolean } = {},
): ReportItemNestedDataRow[] => data.map((item) => {
  const key = item?.key;
  if (key && keyMap[key]) {
    return { id: _.uniqueId(), fields: [] } as ReportItemNestedDataRow;
  }
   
  if (key) keyMap[key] = true;
  return item;
});

const mergeReportNestedItemGroups = (
  oldData: ReportItemNestedDataGroup[],
  newData: ReportItemNestedDataGroup[],
  keyMap: { [key: string]: boolean } = {},
): ReportItemNestedDataGroup[] => {
  const filteredOldArray = oldData.filter(({ key }) => key && key !== 'total');
  const data = [...filteredOldArray, ...newData];

  const result = data.map((item) => {
    const key = item.key ?? '';
    if (keyMap[key] && item.children) {
      return {
        ...item,
        title: '',
        children: mergeReportNestedItemGroups(item.children, [], keyMap),
        ...(item.rows ? { rows: mergeReportNestedItemRows(item.rows, keyMap) } : {}),
      };
    }
    if (keyMap[key]) {
      return { ...item, title: '' };
    }
     
    keyMap[key] = true;
    if (item.children) {
      return {
        ...item,
        children: mergeReportNestedItemGroups(item.children, [], keyMap),
        ...(item.rows ? { rows: mergeReportNestedItemRows(item.rows, keyMap) } : {}),
      };
    }
    return item;
  });

  const innerKeyMap: { [key: string]: boolean } = {};
  const preparedResult = result.reverse().map((item) => {
    const key = item.key ?? '';
    if (innerKeyMap[key]
      && item.children) {
      return { ...item, rows: [] };
    }
     
    innerKeyMap[key] = true;
    return item;
  }).reverse();

  return preparedResult;
};

export default mergeReportNestedItemGroups;